import script from "./ReportsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReportsView.vue?vue&type=script&lang=ts&setup=true"

import "./ReportsView.vue?vue&type=style&index=0&id=fea0d582&lang=scss"

const __exports__ = script;

export default __exports__